import { Link, useNavigate } from 'react-router-dom'
import { Title, Flex, Stack, Text } from 'summon-ui/mantine'
import DiscordLogo from '@assets/icons/socials/discord.svg?react'
import MirrorLogo from '@assets/icons/socials/mirror.svg?react'
import TwitterLogo from '@assets/icons/socials/twitter.svg?react'

export const TITLE = 'You need a closed capsule to mint your NFT!'
export const SUBTITLE = "We're in closed beta, please come back for the open beta."
const SOCIALS = [
  {
    logo: DiscordLogo,
    redirectUrl: 'https://join.zksync.dev/'
  },
  {
    logo: MirrorLogo,
    redirectUrl: 'https://zksync.mirror.xyz/'
  },
  {
    logo: TwitterLogo,
    redirectUrl: 'https://twitter.com/zksync'
  }
]

const TokenGatingError = () => {
  const navigate = useNavigate()
  // If user tries to use back browser button he will be redirected to the same page
  window.onpopstate = () => {
    navigate('/onboarding/error', { replace: true })
  }

  return (
    <Stack h='100%' justify='center' gap='xl'>
      <Stack gap='md'>
        <Title order={2} ta='center'>
          {TITLE}
        </Title>
        <Text ta='center' c='gray.5'>
          {SUBTITLE}
        </Text>
      </Stack>
      <Flex gap='xs' w='100%' justify='center'>
        {SOCIALS.map(({ logo: Logo, redirectUrl }) => (
          <Link key={redirectUrl} to={redirectUrl} target='blank'>
            <Logo />
          </Link>
        ))}
      </Flex>
    </Stack>
  )
}

export default TokenGatingError
